export function pageFilter() {

  // Get select filter
  const filter = document.querySelector('#page-filter');

  // Check if filter exists
  if( filter ) {
    // On change event
    filter.addEventListener('change', function() {

      // Get value of the changed select option
      const url = this.value;

      // Direct window location
      window.location.href = url;

    });
  }

}
